/**
 * Per-outlet theme definitions.
 *
 * DEFAULT_THEME mirrors the hardcoded values in web/index.html :root.
 * When the two drift apart, update BOTH files — see index.html L14-20.
 */

export interface OutletTheme {
  backgroundColor: string;
  surfaceColor: string;
  accentColor: string;
  textColor: string;
  borderColor: string;
  fontFamily: string;
}

export const DEFAULT_THEME: OutletTheme = {
  backgroundColor: '#f5f5f5',
  surfaceColor: '#ffffff',
  accentColor: '#1a73e8',
  textColor: '#202124',
  borderColor: '#dadce0',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

export const FONT_OPTIONS: Array<{ label: string; value: string }> = [
  {
    label: 'System Default',
    value:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  {
    label: 'Georgia',
    value: 'Georgia, "Times New Roman", serif',
  },
  { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
  { label: 'Tahoma', value: 'Tahoma, Geneva, sans-serif' },
  {
    label: 'Trebuchet MS',
    value: '"Trebuchet MS", Helvetica, sans-serif',
  },
  {
    label: 'Courier New',
    value: '"Courier New", Courier, monospace',
  },
];

/** CSS custom-property names mapped to theme fields. */
export const THEME_VARS: Record<keyof OutletTheme, string> = {
  backgroundColor: '--color-bg',
  surfaceColor: '--color-surface',
  accentColor: '--color-primary',
  textColor: '--color-text',
  borderColor: '--color-border',
  fontFamily: '--font-family',
};
